import * as React from "react";

const MailIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
        <path
            fill="#7C3AED"
            d="M4 20q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.413A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.587Q22 5.175 22 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm8-7L4 8v10h16V8zm0-2 8-5H4zM4.037 8V6v12z"
        ></path>
    </svg>
);

export default MailIconSVG;
